import React, { useState, useEffect, memo } from 'react';
import CommonIframe from '../components/common/Iframe';
import TranslateFile from '../Loc/TranslateFile';
import { useSelector } from 'react-redux';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue  } from "../../src/_helpers/storageHelper";

const Commissary = () => {

    const [link, setLink] = useState(null);
    const LoadInmateMainMenuDetails = getStoredValue("inmateMenuList");
    const currentLang = TranslateFile();
    const isPageReloading = useSelector((state) => state.auth?.isPageReload);
    const storedloginResponse = getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails");
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();

    useEffect(() => {
        if (LoadInmateMainMenuDetails && LoadInmateMainMenuDetails.length > 0) {
            const menuLink = LoadInmateMainMenuDetails.find(m => m.MenuName === "Place Order");
            if (menuLink?.MenuExternalLink) {
                let Url = menuLink.MenuExternalLink + "Login/Kiosk/?id=" + storedloginResponse.InmatesResdId + "&pin=" + storedloginResponse.InmatesPinNo;
                setLink(Url);
            }
        }
    }, [LoadInmateMainMenuDetails, isPageReloading]);

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="icon-container">
                    <h3 className="find-inmate-head">{currentLang?.Place_Order}</h3>
                </div>
                <div className="divider mb-3"></div>
                <div className='card-default'><CommonIframe url={link} /></div>
            </div>
        </div>
    );
};

export default memo(Commissary);
